var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 48,
    viewBox: "0 0 51 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.6627 24.0237C50.6814 22.5902 49.9049 21.2728 48.644 20.5813L19.2602 4.43703C17.9441 3.69321 16.3927 3.78459 15.1525 4.63143C13.8896 5.49254 13.2432 7.54242 13.5962 9.02295L16.3393 20.5155C16.6209 21.694 17.6757 22.5238 18.8891 22.5186L35.241 22.4678C36.0784 22.451 36.7575 23.1301 36.7407 23.9675C36.7382 24.7906 36.0691 25.4597 35.2317 25.4765L18.8642 25.5145C17.6508 25.5169 16.5909 26.3504 16.302 27.5306L13.4619 39.0689C13.117 40.4324 13.5102 41.7936 14.4722 42.7556C14.5854 42.8688 14.7127 42.9961 14.8402 43.0951C16.0861 44.0563 17.7177 44.1789 19.1108 43.4366L48.5943 27.4503C49.8594 26.7794 50.6441 25.4571 50.6627 24.0237Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6627 24.0237C50.6814 22.5902 49.9049 21.2728 48.644 20.5813L19.2602 4.43703C17.9441 3.69321 16.3927 3.78459 15.1525 4.63143C13.8896 5.49254 13.2432 7.54242 13.5962 9.02295L16.3393 20.5155C16.6209 21.694 17.6757 22.5238 18.8891 22.5186L35.241 22.4678C36.0784 22.451 36.7575 23.1301 36.7407 23.9675C36.7382 24.7906 36.0691 25.4597 35.2317 25.4765L18.8642 25.5145C17.6508 25.5169 16.5909 26.3504 16.302 27.5306L13.4619 39.0689C13.117 40.4324 13.5102 41.7936 14.4722 42.7556C14.5854 42.8688 14.7127 42.9961 14.8402 43.0951C16.0861 44.0563 17.7177 44.1789 19.1108 43.4366L48.5943 27.4503C49.8594 26.7794 50.6441 25.4571 50.6627 24.0237Z",
    fill: "url(#paint0_linear_3829_3212)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3829_3212",
    x1: 20.2889,
    y1: 1.43188,
    x2: 52.1707,
    y2: 45.4146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07A1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D592"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.6b22d15b5d84706a1e4d341169a9dc11.svg";
export { ForwardRef as ReactComponent };